import React, { useContext, useState, useEffect, useRef } from 'react';
import "../styles/SearchCategories.css";
import SearchBar from './SearchBar';
import { AuthContext } from '../contexts/AuthContext';

const SearchCountyName = ({ setShowSearchBar, showCounty}) => {
    
    //let globIsSearched = false;
    const { countyName, updateCountyName } = useContext(AuthContext); // Access countyName and updateCountyName from AuthContext
    const { zipCode, updateZipCode } = useContext(AuthContext); // Access zipCode and updateZipCode from AuthContext
    const [locationQuery, setLocationQuery] = useState(countyName || ''); // Initialize with persisted county name
    const [isSearched, setIsSearched] = useState(!!countyName); // Set based on whether a county name exists
    const [isCountyNameRequired, setIsCountyNameRequired] = useState(false);
    const [countyNameError, setCountyNameError] = useState(false); // New state for county name error
    const [highlightCountyNameInput, setHighlightCountyNameInput] = useState(false); // New state to highlight input
    const [isBlinking, setIsBlinking] = useState(false); // State to track the blinking status

    // Create a ref for the county anme input field
    // useRef is a React Hook that lets you reference a value that’s not needed for rendering.
    // Example: const ref = useRef(initialValue)
    const countyNameInputRef = useRef(null);

    // Focus the county name input field when the component mounts
    useEffect(() => {
        if (countyNameInputRef.current) {
            countyNameInputRef.current.focus();
        }
    }, []);

    //If the user inputs nothihg or blank spaces, tells user that letters are required.
    //If the user inputs numbers and special characters, tells user they need to input letters.
    //If user input is right, sets location Query to user input.
    const handleCountyNameSearch = (e) => {

        e.preventDefault();

        if (locationQuery.trim() === '') {

            setIsCountyNameRequired(true);
            setCountyNameError(false); // Reset error state if empty
        } else if (!/^[A-Za-z\s\-]+$/.test(locationQuery)) {

            setCountyNameError(true); // Set error if non-alphabetical characters are present
            setIsCountyNameRequired(false); // Reset required state
        } else {

            setIsSearched(true);
            setIsCountyNameRequired(false);
            setCountyNameError(false); // Reset error state on valid input
            updateCountyName(locationQuery); // Persist the county name in context and localStorage
            
            updateZipCode(''); // Persist the zip code in context and localStorage
            //setShowSearchBar(true); //Makes the services search bar appear
            //setCountyNamePage(locationQuery); //Saves the county name for passing it to the menu. 
        }
    };

    //when the user removes the county name, all elements are set to initial states.
    const handleRemoveFilter = () => {

        setIsSearched(false);
        setLocationQuery('');
        setIsCountyNameRequired(false);
        setCountyNameError(false); // Reset error state
        updateCountyName(''); // Clear the county name from context and localStorage
        
        setShowSearchBar(false); //makes the services search bar dissappear.
    };

    //real time checks if user is typing in county name search box, and changes location query.
    const handleInputChange = (e) => {

        setLocationQuery(e.target.value);

        // Reset the red border and required notice if the user starts entering the county name
        if (e.target.value !== '') {
            setIsCountyNameRequired(false);
            setIsBlinking(false); // Stops keeping the solid red border
        }
    };

    return (

        //county name search box
        <div className="search-container" style={showCounty ? {}: {pointerEvents: "none", opacity: "0.4"}}>

            {/* when search button is clicked */}
            <form onSubmit={handleCountyNameSearch}>

                {/* <h2 className="search-title">Enter a county name to get started </h2> */}
                <div className={`search-categories-bar-container ${highlightCountyNameInput ? 'highlight' : (isBlinking ? 'still' : '')}`}>

                    {/* if a proper county name as been entered, turns searhc box into a filter box
                    If not, gives a message. */}
                    {/* {(isSearched && showCounty) ? ( */}
                    {(isSearched && showCounty && countyName != '') ? (    
                        
                        <div className="filter-box">

                            <div className="zipCode">

                                <span>County Name: {locationQuery}</span>
                                <button type="button" onClick={handleRemoveFilter}>×</button>
                            </div>

                            {/* allows the search bar and menu to be shown on homepage */}
                            {setShowSearchBar(true)}
                        </div>
                    ) : (

                        <div className={`zip-code-input-container ${highlightCountyNameInput ? 'highlight' : (isBlinking ? 'still' : '')}`}>
                            
                            <SearchBar
                                ref={countyNameInputRef} // Attach ref to the input
                                placeholder="Enter County Name"
                                value={locationQuery}
                                onChange={handleInputChange}
                            />
                            {isCountyNameRequired && (
                                <span className="required-notice">Required*</span>
                            )}
                            {countyNameError && (
                                <span className="required-notice">Please enter letters only*</span>
                            )}
                        </div>
                    )}
                </div>
            </form>
        </div>
    )
};

export default SearchCountyName;